import React from "react"
import PropTypes from "prop-types"
import { Alert, List } from "antd"

import { ImportErrorShape } from "@shapes"


const ImportModalErrors = ({ errors }) => {
  return (
    <Alert
      type="error"
      message="Errors"
      closable={false}
      description={
        <List
          size="small"
          dataSource={errors}
          itemLayout="vertical"
          renderItem={item =>
            (
              <List.Item>
                {`[Row ${item.index}] ${item.reason}`}
              </List.Item>
            )
          }
        />
      }
    />
  )
}

ImportModalErrors.propTypes = {
  errors: PropTypes.arrayOf(ImportErrorShape).isRequired
}

export default ImportModalErrors
